/**
 * localStorage persistence for the doctor's in-call observations scratchpad.
 * Keyed on the FHIR encounter id (stable across an interrupted-visit resume,
 * which swaps the scribe session id). Lives apart from `<DoctorObservations>`
 * so the component file only exports a component (Vite fast-refresh).
 */
const STORAGE_KEY_PREFIX = 'zoom-panel-doctor-observations:'

export function buildObservationsStorageKey(encounterId: string | null | undefined): string | null {
  if (!encounterId) return null
  return `${STORAGE_KEY_PREFIX}${encounterId}`
}

export function readObservationsFromStorage(encounterId: string | null | undefined): string {
  if (typeof window === 'undefined') return ''
  const key = buildObservationsStorageKey(encounterId)
  if (!key) return ''
  try {
    return window.localStorage.getItem(key) ?? ''
  } catch {
    return ''
  }
}

/** Cleared after a successful finalize so a fresh session doesn't inherit old notes. */
export function clearObservationsFromStorage(encounterId: string | null | undefined): void {
  const key = buildObservationsStorageKey(encounterId)
  if (!key || typeof window === 'undefined') return
  try {
    window.localStorage.removeItem(key)
  } catch {
    // localStorage may throw in private mode — irrelevant on clear.
  }
}
